import type { FilterSpecification } from "mapbox-gl";

/**
 * Zip points are zip codes with no geographic area, stored as a single Point rather than a polygon,
 * so a line layer draws nothing for them and only their label appears. Shared by the county and
 * zip-project Network Coverage Maps so the two stay in step.
 */
export const EXCLUDE_ZIP_POINTS_FILTER: FilterSpecification = ["!=", ["geometry-type"], "Point"];

// Match-all rather than undefined: react-map-gl re-adds layers on style change, and addLayer rejects `filter: undefined`.
export const INCLUDE_ZIP_POINTS_FILTER: FilterSpecification = ["boolean", true];

export const ZIP_POINTS_INFO =
  "Zip Points are zip codes that have no geographic area and are based at one specific point, enclosed entirely by a different zip code.";
